import { CollectionOwnerType } from '../types';


export const CollectionOwnerTypes = [
  { name: 'Personal', value: CollectionOwnerType.Taster },
  { name: 'Organization', value: CollectionOwnerType.Organization }
];
